import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useBlackBnfReportList = (type, term = null) => useQuery({ queryKey: ['black-bnf-list', term, type], queryFn: async () => {
    const callback = await API.get(`/black-bnf/list?type=${type}${term ? `&term=${term}` : ''}`)
    return callback?.data
}})

export default useBlackBnfReportList